import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Alert, Badge, Col, Container, FloatingLabel, Form, Image, Row, Spinner, Table } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import { Bar, Line } from 'react-chartjs-2';
import { LoginInfo } from '../App';
import { Button } from '@mui/material';

const Callback = () => {
    function getRegistrationByDay(){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/invest/data/1000").then((r)=>{
            return r.json()
        })
    }
    function getInvestList(){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/invest/list").then((r)=>{
            return r.json()
        })
    }
    function getTransaction(){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/invest/transaction").then((r)=>{
            return r.json()
        })
    }
    function buy(stockCode,count){
        return new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/invest/buy",{stockCode:stockCode,count:count}).then((r)=>{
            return r.json()
        })
    }
    function sell(stockCode,count){
        return new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/invest/sell",{stockCode:stockCode,count:count}).then((r)=>{
            return r.json()
        })
    }
    function getPayoutsSetupStatus(){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/monetization/payoutsSetupStatus").then((r)=>{
            return r.json()
        })
    }
    function linkUserId(sessionId){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/checkout/link/"+sessionId).then((r)=>{
            return r.json()
        })
    }
    // ダイアログ
    const [show, setShow] = useState(false)
    const [dialogTitle, setDialogTitle] = useState("")
    const [dialogMessage, setDialogMessage] = useState("")
    const [okButtonShow,setOkButtonShow] = useState(false)
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }



    const {t,i18n} = useTranslation()
    const params = useParams()
    const type = params.type
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    // ナビゲーション
    const navigate = useNavigate()
    const location = useLocation()
    const [status,setStatus] = useState(0)
    const [link,setLink] = useState()
    const [planUserId,setPlanUserId] = useState("")
    const [redirectCountdown, setRedirectCountdown] = useState(null)
    const [isVideoGeneration, setIsVideoGeneration] = useState(false)

	useEffect(() => {
		document.querySelector("title").textContent = "移動中・・・ - ourt AI"
        
        // URL パラメータから ref を取得して動画生成成功時かを判定
        const urlParams = new URLSearchParams(window.location.search)
        const ref = urlParams.get('ref')
        
        if(ref === 'video_generation') {
            setIsVideoGeneration(true)
            setRedirectCountdown(3)
        }
        
        if(type === undefined){
            window.location.href = "/"
        } else if(type === "payoutsSetup"){
            // 口座設定後の設定状況確認
            getPayoutsSetupStatus().then(r => {
                if(r.result){
                    if(r.charges_enabled && r.payouts_enabled){
                        navigate("/callback/payoutsSetupComplete")
                    } else if(r.charges_enabled && !r.payouts_enabled){
                        setStatus(1)
                        setLink(r.account_link)
                    }
                } else {
                    setStatus(2)
                }
            })
        } else if(type === "success"){
            const sessionId = window.location.href.substring(window.location.href.indexOf("session_id=")).replace("session_id=","")
            if(sessionId.indexOf("cs_") === -1) navigate("/callback/canceled")
            linkUserId(sessionId).then(r => {
                if(r.result){
                    
                } else {
                    navigate("/callback/canceled")
                }
            })
        } else if(type === "start_support"){
            const userId = window.location.href.substring(window.location.href.indexOf("user_id=")).replace("user_id=","")
            if(userId && userId.length === 36){
                setPlanUserId(userId)
            }
        } else if(type === "end_support"){
            //window.location.reload()
        }
	},[])

    // 動画生成成功時のカウントダウンタイマー
    useEffect(() => {
        if (isVideoGeneration && redirectCountdown > 0) {
            const timer = setTimeout(() => {
                setRedirectCountdown(redirectCountdown - 1)
            }, 1000)
            return () => clearTimeout(timer)
        } else if (isVideoGeneration && redirectCountdown === 0) {
            navigate('/generate/video')
        }
    }, [redirectCountdown, isVideoGeneration, navigate])

    // 手動転送ボタンハンドラー
    const handleVideoGenerationRedirect = () => {
        navigate('/generate/video')
    }

    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} />
        <Header />
        <Category />
        <Container className='text-center'>
            {planUserId !== "" ? (
                <Image src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/profile/"+planUserId+".jpg"} style={{marginLeft:"20px",width:"100px",height:"auto",borderRadius:"50%",border:"3px solid #FFFFFF"}} />
            ) : ""}
            {type === "payoutsSetup" && status === 0 ? <><Spinner animation="border" size="sm" /> 口座設定確認中・・・</> : ""}
            {type === "payoutsSetup" && status === 1 ? <>提出された書類を確認しています。審査完了までもうしばらくお待ちください。<br /><Button onClick={() => window.location.href = link}>口座管理</Button></> : ""}
            {type === "payoutsSetup" && status === 2 ? <>口座設定は完了していません。不足がないかもう一度確認してください</> : ""}
            {type === "payoutsSetupComplete" ? (
                <><Icon.CheckCircle style={{color:"#007800"}} /> 口座設定が完了しました。</>
            ) : ""}
            {type === "success" ? <Container style={{fontSize:"24px"}}><Icon.CheckCircle style={{color:"green"}}/> 決済が完了しました。</Container> : ""}
            {isVideoGeneration && type === "success" ? (
                <Container className="mt-4">
                    <div style={{fontSize:"18px", marginBottom:"20px"}}>
                        動画生成ページに転送します...
                    </div>
                    <div style={{fontSize:"32px", color:"#007bff", marginBottom:"20px"}}>
                        {redirectCountdown}
                    </div>
                    <Button 
                        variant="primary" 
                        onClick={handleVideoGenerationRedirect}
                        style={{marginTop:"10px"}}
                    >
                        すぐに転送する
                    </Button>
                </Container>
            ) : ""}
            {type === "canceled" ? <Container style={{fontSize:"24px"}}><Icon.ExclamationCircle style={{color:"red"}}/> 決済が失敗しました。</Container> : ""}
            {type === "start_support" ? <Container style={{fontSize:"24px"}}><Icon.CheckCircle style={{color:"green"}}/> 支援を開始しました。</Container> : ""}
            {type === "end_support" ? <Container style={{fontSize:"24px"}}><Icon.CheckCircle style={{color:"#555555"}}/> 支援を停止しました。</Container> : ""}
            {planUserId !== "" ? (
                <Button variant='contained' className='mt-3' onClick={() => navigate("/user/"+planUserId)}>クリエイターページへ</Button>
            ) : ""}
            {type === "auth_success" ? <Container style={{fontSize:"24px"}}><Icon.CheckCircle style={{color:"green"}}/> 認証しました。</Container> : ""}
            {type === "auth_failed" ? <Container style={{fontSize:"24px"}}><Icon.ExclamationCircle style={{color:"red"}}/> 認証に失敗しました。</Container> : ""}
        </Container>
        <Footer />
    </div>
    )
}

export default Callback;
